<section class="px-base pt-lg container mx-auto">
  <h1 class="c-h1 mb-7">Accede al Gestor de Autorizaciones del Gobierno de Aragón</h1>
  @if (!loadingToken()) {
    <iframe
      id="mfe_iframe"
      title="Módulo de firma electrónica e identificación"
      [src]="mfeUrl | safeUrl"
      class="h-[630px] w-[1024px]"></iframe>
  } @else {
    <desy-spinner classes="mt-xl" />
  }
</section>
